import React, { useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { updatePartNumber } from '../../../store/software-library-management/actions';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';

const PartNumberCell = ({ row }: any) => {
  const [value, setValue] = useState(row.values.partNumber);
  const reference = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  const onSubmit = async () => {
    if (value && value.trim() !== row.original.partNumber && value !== '') {
      const partNumber = await dispatch(updatePartNumber(row, { partNumber: value.trim() }));
      setValue(partNumber);
    } else {
      dispatch(enqueueSnackbarAction({
        message: 'Part number cannot be empty',
        options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
      }))

    }
  };
  const handleChange = (event: any) => {
    setValue(event.target.value);
  };
  const handleKeyUp = (event: any) => {
    if (event.keyCode === 13) {
      reference?.current?.blur();
    }
  };
  const handleBlur = () => {
    onSubmit();
  };

  return (
    <Tooltip
      arrow
      placement="right"
      title="Please indicate the version number with a hyphen before saving the Part Number. (Eg.1234-00)"
      id="partNumberToolTip"
    >
      <input
        ref={reference}
        type="text"
        value={value}
        onBlur={handleBlur}
        onInput={handleChange}
        onKeyUp={handleKeyUp}
      />
    </Tooltip>
  );
};

export default PartNumberCell;
